import $ from 'jquery'

export default {
  name: 'modal-import-groupe-visites-medicales',
  components: {},
  props: [],
  data () {
    return {
      is_clicked: false,
      loading: false,
      selected: {
        groupes:[]
      }
    }
  },
  computed: {
    groupesImport(){
      return this.$store.getters["importGroupeParametrageVM"];
    },
    latestVisiteEnCours(){
      return this.$store.getters["latestVisiteMedicaleAnnuelle"]
    },


  },
  mounted () {
    this.$store.dispatch("getGroupeToImportParametrageVM",0)
  },
  methods: {

    importGroupe: function(){
      this.is_clicked = true
      if(this.selected.groupes.length ==0){
        $('.error_empty').fadeIn()
        return
      }
      this.loading = true
      $('.error_empty').fadeOut()

      this.$store.dispatch("importGlobalGroupesInSociete",{id:this.$route.params.id, data:this.selected}).then(
        () =>{
          this.loading = false
          let societe_id = this.$route.params.id
          this.selected.groupes = [];
          $('.modal').modal('hide')
          this.successImportGroupeVM()
          if(Object.keys(this.latestVisiteEnCours).length !==0){
            let data = {visite_medicale_id: this.latestVisiteEnCours.id}
            this.$store.dispatch('initVisitesMedicalesProgrammation',{societe_id: societe_id, data:data}).then(
              () => {
                this.$store.dispatch('getProgrammationsVisitesMedicales',this.latestVisiteEnCours.id)
                this.$store.dispatch('getSocieteVisiteMedicaleStats',this.latestVisiteEnCours.id)
              }
            )

          }

        }
      )

    },
    successImportGroupeVM: function() {
      this.$toasted.show('Importation réussie', {
          duration: 3000,
          action: [{
              text: 'X',
              onClick: (e, toastObject) => {
                  toastObject.goAway(0);
              }
          }],
          theme: 'toasted-primary',
          type: 'success',
          position: 'top-center'

      })
  },


  }
}


